// Brand motifs: 2px strokes, Navy 20% on light, Ice Blue 25% on Navy. One motif per section.
const STROKE = { light: "rgba(9,19,34,0.2)", dark: "rgba(222,235,240,0.25)" };

// Deterministic segment pattern (fractions of the row) so the sequence reads as measured, not random.
const ROWS = [
  [0, 0.42, 0.5, 1], [0, 0.18, 0.26, 0.74, 0.8, 1], [0, 0.6, 0.68, 1], [0.12, 0.55, 0.62, 1],
  [0, 0.3, 0.38, 0.86], [0, 0.72, 0.8, 1], [0.2, 0.48, 0.56, 1], [0, 0.36, 0.44, 0.66, 0.74, 1],
  [0, 0.52, 0.6, 0.92], [0.08, 0.8, 0.88, 1], [0, 0.24, 0.32, 1], [0, 0.64, 0.72, 1],
];

export const SequenceLines = ({ tone = "light", rows = 12, gap = 18, className = "" }) => {
  const width = 100;
  const height = rows * gap;
  return (
    <svg className={className} viewBox={`0 0 ${width} ${height}`} preserveAspectRatio="none" aria-hidden="true" focusable="false">
      {Array.from({ length: rows }).map((_, r) => {
        const seg = ROWS[r % ROWS.length];
        const y = r * gap + gap / 2;
        const lines = [];
        for (let i = 0; i < seg.length; i += 2) {
          lines.push(
            <line key={i} x1={seg[i] * width} x2={seg[i + 1] * width} y1={y} y2={y} stroke={STROKE[tone]} strokeWidth="2" vectorEffect="non-scaling-stroke" />
          );
        }
        return <g key={r}>{lines}</g>;
      })}
    </svg>
  );
};

export const StructuredLines = ({ tone = "light", cols = 5, rows = 4, className = "" }) => {
  const s = 40;
  const w = cols * s;
  const h = rows * s;
  const c = STROKE[tone];
  return (
    <svg className={className} viewBox={`-1 -1 ${w + 2} ${h + 2}`} aria-hidden="true" focusable="false">
      {Array.from({ length: cols + 1 }).map((_, i) => (
        <line key={`v${i}`} x1={i * s} x2={i * s} y1={0} y2={h} stroke={c} strokeWidth="2" vectorEffect="non-scaling-stroke" />
      ))}
      {Array.from({ length: rows + 1 }).map((_, i) => (
        <line key={`h${i}`} x1={0} x2={w} y1={i * s} y2={i * s} stroke={c} strokeWidth="2" vectorEffect="non-scaling-stroke" />
      ))}
    </svg>
  );
};
